import { computed, ref } from "vue";
import { useDialog } from "primevue/usedialog";
import type { DynamicDialogInstance } from "primevue/dynamicdialogoptions";
import type { Role } from "@/composables/role-manager";
import RoleEditor from "@/components/Roles/RoleEditor.vue";
import { useHotKeys } from "./hotkeys";
import { useCurrentEntityManager } from "@/stores/entity-store";

export const useEditRoleDialog = () => {
    const { domain } = useCurrentEntityManager();
    const dialog = useDialog();
    const dialogRef = ref<DynamicDialogInstance & { visible?: boolean }>();
    const isVisible = computed(() => Boolean(dialogRef.value?.visible));

    const registerHotKey = () => {
        const { addHotKey } = useHotKeys();

        addHotKey(
            "n r",
            (e) => {
                if (!isVisible.value && domain.value?.identity) {
                    e.preventDefault();
                    open();
                }
            },
            "Open new role dialog."
        );
    };

    const open = (role?: Role) => {
        dialogRef.value = dialog.open(RoleEditor, {
            props: {
                header: role ? "Edit role" : "New role",
                style: {
                    maxWidth: "600px",
                    width: "80%",
                },
                modal: true,
                maximizable: false,
                draggable: false,
            },
            data: role,
        });
    };

    return { registerHotKey, open, isVisible };
};
